import Cookies from 'js-cookie';

export const getAnonUser = () => {
  const pianoUid = Cookies.get('pianoUid');
  if (pianoUid) return pianoUid;
  const anonUser = Cookies.get('anonUserOptimizely') || Math.random().toString(36).substr(2, 9);
  Cookies.set('anonUserOptimizely', anonUser);
  return anonUser;
};

export const OPTIMIZELY_EVENT_VALUES = {
  inContentAd0: 1.11,
  inContentAd1: 0.82,
  inContentAd2: 0.84,
  inContentAd3: 0.86,
  inContentAd4: 0.85,
  inContentAd5: 0.97,
  inContentAd6: 0.82,
  inContentAd7: 0.82,
  inContentAd8: 0.82,
  inFeedAd0: 10.25,
  inFeedAd1: 9.73,
  inFeedAd2: 7.86,
  inFeedAd3: 10.83,
  inFeedAd4: 7.86,
  inFeedAd5: 7.86,
  stnPlayer: 4.6,
  leaderboardTop: 0.99,
  siderailFlex1: 3.97,
  siderailFlex2: 7.59,
  siderailSticky: 3.05,
  newsletterSubscription: 300,
  signUpValue: 100,
  defaultAdImpression: 0.82,
  finishedArticle: 0,
};

export const OPTIMIZELY_AD_ELEMENTS = {
  Leaderboard0: {
    name: 'leaderboard_ad',
    value: OPTIMIZELY_EVENT_VALUES.leaderboardTop,
  },
  fortunecom_incontent0: {
    name: 'saw_first_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd0,
  },
  fortunecom_infeed0: {
    name: 'saw_first_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd0,
  },
  fortunecom_incontent1: {
    name: 'saw_second_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd1,
  },
  fortunecom_infeed1: {
    name: 'saw_second_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd1,
  },
  fortunecom_incontent2: {
    name: 'saw_third_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd2,
  },
  fortunecom_infeed2: {
    name: 'saw_third_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd2,
  },
  fortunecom_incontent3: {
    name: 'saw_fourth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd3,
  },
  fortunecom_infeed3: {
    name: 'saw_fourth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd3,
  },
  fortunecom_incontent4: {
    name: 'saw_fifth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd4,
  },
  fortunecom_infeed4: {
    name: 'saw_fifth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd4,
  },
  fortunecom_incontent5: {
    name: 'saw_sixth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd5,
  },
  fortunecom_incontent6: {
    name: 'saw_seventh_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd6,
  },
  fortunecom_incontent7: {
    name: 'saw_eighth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd7,
  },
  fortunecom_incontent8: {
    name: 'saw_ninth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd8,
  },
  fortunecom_siderail_flex_1: {
    name: 'saw_static_right_rail',
    value: OPTIMIZELY_EVENT_VALUES.siderailFlex1,
  },
  fortunecom_siderail_article_sticky: {
    name: 'saw_sticky_right_rail',
    value: OPTIMIZELY_EVENT_VALUES.siderailSticky,
  },
  fortunecom_sticky_footer: {
    name: 'saw_footer_ad',
    value: OPTIMIZELY_EVENT_VALUES.leaderboardTop,
  },
};
